import React from 'react';
import Head from "next/head";
import Index from "../views/Consent";

const Consent = () => {
  return (
    <div>
      <Head>
        <title>North West Region Virtual Care Clinic</title>
        <meta
          name="North West Virtual Care Clinic - Consent"
          content="The North West Region Virtual Care Clinic is supported and staffed by Nurse Practitioners in Ontario"
        />
      </Head>
        <Index />
    </div>
  );
};

export default Consent;